import { Button } from "@mui/material";
import { GetRoute, routeApiErrorMessage } from "../../services/RoutingAdapter";
import { useEnvironmentName } from "../../stores/EnvironmenSettingStore";
import { useBarrierPoints, useFromAddress, useToAddress, useViaPoints } from "../../stores/RouteLocationStore";
import { useRouteSettings } from "../../stores/RouteSettingsStore";
import { useRouteStoreActions } from "../../stores/RouteStore";
import { useUserNotificationActions } from "../../stores/UserNotificationStore";

export function UpdateRouteButton() {
    const routeSettings = useRouteSettings();

    const fromAddress = useFromAddress();
    const toAddress = useToAddress();
    const viaPoints = useViaPoints();
    const barrierPoints = useBarrierPoints();
    const environmentName = useEnvironmentName();

    const { setFeedbackMessage } = useUserNotificationActions();

    const { setRouteResponse, setSelectedRouteIndex, setIsLoading, setRouteDrawerOpen } = useRouteStoreActions();

    const onClick = (event: any) => {
        if (fromAddress !== null && toAddress !== null) {
            setIsLoading(true);
            GetRoute(routeSettings, fromAddress, toAddress, viaPoints, barrierPoints, environmentName).then(route => {
                setRouteResponse(route);
                setRouteDrawerOpen(true);
                setSelectedRouteIndex(0);
                setIsLoading(false);
            }).catch(error => {
                setFeedbackMessage({ message: routeApiErrorMessage(error), severity: "error" });
                setRouteResponse(null);
                setRouteDrawerOpen(false);
                setIsLoading(false);
            })
        }
    }

    const disabled = fromAddress === null || toAddress === null;

    return (
        <Button style={{marginTop: '20px'}} onClick={onClick} variant="contained" disabled={disabled}>Oppdater rute</Button>
    )
}